import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { UtilService } from './services/util/util.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { Logger } from './services/logger/logger.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'frontend';

  private spinnerStateChanged: Subscription = new Subscription();
  public spinnerVisible: boolean = false;

  constructor(private utilService: UtilService, private router: Router){

  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event : any) {

    localStorage.setItem('backBtnclicked', 'true_' + this.router.url);

  }

  ngOnInit(){
    // subscribe to spinner state but make the assignment async to avoid
    // ExpressionChangedAfterItHasBeenCheckedError when the observable
    // emits during change-detection.
    this.spinnerStateChanged = this.utilService.spinnerState.subscribe(
      (data) => {
        // schedule update on next macrotask
        setTimeout(() => {
          this.spinnerVisible = this.utilService.spinnerShowCount > 0;
        });
      }
    );
    Logger.enableProductionMode();
  }

  ngOnDestroy() {
    this.spinnerStateChanged.unsubscribe();
  }
}
